import Cookies from 'js-cookie';
import qs from 'query-string';
import { get } from 'lodash';
import { SEARCH_TEXT, SEARCH_BY } from './constants/constants';

export const getCookie = () => {
    Cookies.get('HP_Country');
}

export const setCookie = (key, value) => {
    Cookies.set(key, value)
}


export const getQueryParam = (props, key) => {
    const search = get(props, 'history.location.search', '');
    const query = qs.parse(search);
    if (key) {
        return query[key];
    } else {
        return query;
    }
};

export const getURLQueryString = (searchText, searchBy) => {
    if (!searchText && !searchBy) {
        return null;
    }
    let params = [];
    searchText && params.push(`${SEARCH_TEXT}=${searchText}`)
    searchBy && params.push(`${SEARCH_BY}=${searchBy}`)
    // console.log('23', `?${params.join('&')}`)
    return `?${params.join('&')}`
}
export const getURLQueryStringBySearch = (searchText) => {
    if (!searchText) {
        return null;
    }
    let params = [];
    searchText && params.push(`${SEARCH_TEXT}=${searchText}`)
    //searchBy && params.push(`${SEARCH_BY}=${searchBy}`)
    // console.log('23', `?${params.join('&')}`)
    return `?${params.join('&')}`
}
export const getLocationObject = (searchText, searchBy) => {
    let queryString = '';
    if (!searchText && !searchBy) {
        queryString = '';
    }
    let params = [];
    searchText && params.push(`${SEARCH_TEXT}=${searchText}`)
    searchBy && params.push(`${SEARCH_BY}=${searchBy}`)
    queryString = `?${params.join('&')}`
    return {
        pathname: `${process.env.REACT_APP_HOME_DIRECTORY}`,
        search: queryString || undefined
    }
}

export const getAuthHeader = () => {
   // console.log('aa', process.env.REACT_APP_API_USERNAME, process.env.REACT_APP_API_PASSWORD)
    const token = Buffer.from(`${process.env.REACT_APP_API_USERNAME}:${process.env.REACT_APP_API_PASSWORD}`).toString('base64')
    return {
        'Authorization': `Basic ${token}`,
    }
}

export const getAuthHeaderUID = () => {
     const token = Buffer.from(`${process.env.REACT_APP_API_USERNAME}:${process.env.REACT_APP_API_PASSWORD}`).toString('base64')
     return {
        'Authorization': `Basic ${token}`,
        'content-type': 'application/x-www-form-urlencoded',
     }
 }

 export const bodyParametersUID = (code) => {
    return {
        'grant_type': 'authorization_code',
        'code': `${code}`,
    }
 };